// // css =>
// import "../../BaseStructure.css";
// import Styled from "./content-box.module.css";

// // language =>
// import { getTranslation } from '../../i18n/get-translation';
// import { useLanguage } from '../../context/language-context';

// // context =>
// import { useTheme } from '../../context/theme-context';

// // motion =>
// import { motion, AnimatePresence } from "framer-motion";

// // react =>
// import { useState } from "react";

// const ContentBox = (props) => {
//     const { theme } = useTheme();
//     const { language } = useLanguage();
//     const t = (key) => getTranslation(language, key);

//     const [selectedIndex, setSelectedIndex] = useState(null);

//     const closeLightbox = () => setSelectedIndex(null);

//     return (
//         <div className={`col-6 ${Styled.content_box_section}`}>
//             <div
//                 className={`row ${Styled.content_box}`}
//                 style={{
//                     backgroundColor: theme === "day" ? "#C9CCC2" : "",
//                     border: theme === "day" ? "none" : ""
//                 }}>
//                 <div className="col-6">
//                     <p
//                         style={{
//                             color: theme === "day" ? "#000000" : "",
//                             textAlign: language === "fa" ? "right" : "",
//                             marginRight: language === "fa" ? "15px" : ""
//                         }}>{props.numberOfContentText}</p>
//                     <p
//                         style={{
//                             color: theme === "day" ? "#000000" : "",
//                             textAlign: language === "fa" ? "right" : "",
//                             marginRight: language === "fa" ? "15px" : ""
//                         }}
//                         className={Styled.view_all_text}>{t('bodyViewAllButton')}</p>
//                 </div>

//                 <div className={`col-6 ${Styled.content_box_icon_box}`}>
//                     <img src={props.contentBoxIcon} alt="آیکون باکس محتوا" />
//                 </div>

//                 <div className={`col-12 ${Styled.content_picture_box}`}>
//                     {
//                         props.contents && props.contents.length > 0 ? (
//                             props.contents.map((item, index) => (
//                                 props.contentType === "video" ? (
//                                     <motion.video
//                                         key={index}
//                                         layoutId={`media-${index}`}
//                                         src={item}
//                                         muted
//                                         className={Styled.thumbMedia}
//                                         whileHover={{ scale: 1.03 }}
//                                         onClick={() => setSelectedIndex(index)}
//                                     />
//                                 ) : (
//                                     <motion.img
//                                         key={index}
//                                         layoutId={`media-${index}`}
//                                         loading="lazy"
//                                         src={item}
//                                         alt="تصویر نمونه کار"
//                                         className={Styled.thumbMedia}
//                                         whileHover={{ scale: 1.03 }}
//                                         onClick={() => setSelectedIndex(index)}
//                                     />
//                                 )
//                             ))
//                         ) : (
//                             <p style={{ color: theme === "day" ? "#000000" : "" }}>
//                                 {t('noContent')}
//                             </p>
//                         )
//                     }
//                 </div>
//             </div>

//             <AnimatePresence>
//                  {selectedIndex !== null && (
//                     <motion.div
//                         className={Styled.overlay}
//                         initial={{ opacity: 0 }}
//                         animate={{ opacity: 1 }}
//                         exit={{ opacity: 0 }}
//                         onClick={closeLightbox}
//                     >
//                         <motion.div
//                             initial={{ scale: 0.8, opacity: 0 }}
//                             animate={{ scale: 1, opacity: 1 }}
//                             exit={{ scale: 0.8, opacity: 0 }}
//                             transition={{ type: "spring", stiffness: 300, damping: 30 }}
//                             onClick={(e) => e.stopPropagation()}
//                         >
//                             {props.contentType === "video" ? (
//                                 <video
//                                     src={props.contents[selectedIndex]}
//                                     controls
//                                     autoPlay
//                                     className={Styled.fullscreenMedia}
//                                 />
//                             ) : (
//                                 <img
//                                     src={props.contents[selectedIndex]}
//                                     alt="تصویر بزرگ‌شده"
//                                     className={Styled.fullscreenMedia}
//                                 />
//                             )}
//                         </motion.div>
//                     </motion.div>
//                 )}
//             </AnimatePresence>
//         </div>
//     );
// }

// export default ContentBox;

// css =>
import "../../BaseStructure.css";
import Styled from "./content-box.module.css";

// language =>
import { getTranslation } from '../../i18n/get-translation';
import { useLanguage } from '../../context/language-context';

// context =>
import { useTheme } from '../../context/theme-context';

// motion =>
import { motion, AnimatePresence } from "framer-motion";

// react =>
import { useState } from "react";

const ContentBox = (props) => {
    const { theme } = useTheme();
    const { language } = useLanguage();
    const t = (key) => getTranslation(language, key);

    const [selectedIndex, setSelectedIndex] = useState(null);
    const [showAll, setShowAll] = useState(false);

    const closeLightbox = () => setSelectedIndex(null);
    const closeGallery = () => setShowAll(false);

    return (
        <div className={`col-6 ${Styled.content_box_section}`}>
            <div
                className={`row ${Styled.content_box}`}
                style={{
                    backgroundColor: theme === "day" ? "#C9CCC2" : "",
                    border: theme === "day" ? "none" : ""
                }}>
                <div className="col-6">
                    <p
                        style={{
                            color: theme === "day" ? "#000000" : "",
                            textAlign: language === "fa" ? "right" : "left",
                            marginRight: language === "fa" ? "15px" : ""
                        }}>{props.numberOfContentText}</p>
                    <p
                        style={{
                            color: theme === "day" ? "#000000" : "",
                            textAlign: language === "fa" ? "right" : "left",
                            marginRight: language === "fa" ? "15px" : "",
                            cursor: "pointer"
                        }}
                        onClick={() => setShowAll(true)}
                        className={Styled.view_all_text}>{t('bodyViewAllButton')}</p>
                </div>

                <div className={`col-6 ${Styled.content_box_icon_box}`}>
                    <img src={props.contentBoxIcon} alt="آیکون باکس محتوا" />
                </div>

                <div className={`col-12 ${Styled.content_picture_box}`}>
                    {
                        props.contents && props.contents.length > 0 ? (
                            props.contents.map((item, index) => (
                                props.contentType === "video" ? (
                                    <motion.video
                                        key={index}
                                        layoutId={`media-${index}`}
                                        src={item}
                                        muted
                                        className={Styled.thumbMedia}
                                        whileHover={{ scale: 1.03 }}
                                        onClick={() => setSelectedIndex(index)}
                                    />
                                ) : (
                                    <motion.img
                                        key={index}
                                        layoutId={`media-${index}`}
                                        loading="lazy"
                                        src={item}
                                        alt="تصویر نمونه کار"
                                        className={Styled.thumbMedia}
                                        whileHover={{ scale: 1.03 }}
                                        onClick={() => setSelectedIndex(index)}
                                    />
                                )
                            ))
                        ) : (
                            <p style={{ color: theme === "day" ? "#000000" : "" }}>
                                {t('noContent')}
                            </p>
                        )
                    }
                </div>
            </div>

            {/* لایت‌باکس تکی */}
            <AnimatePresence>
                {selectedIndex !== null && (
                    <motion.div
                        className={Styled.overlay}
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        onClick={closeLightbox}
                    >
                        <motion.div
                            initial={{ scale: 0.8, opacity: 0 }}
                            animate={{ scale: 1, opacity: 1 }}
                            exit={{ scale: 0.8, opacity: 0 }}
                            transition={{ type: "spring", stiffness: 300, damping: 30 }}
                            onClick={(e) => e.stopPropagation()}
                        >
                            {props.contentType === "video" ? (
                                <video
                                    src={props.contents[selectedIndex]}
                                    controls
                                    autoPlay
                                    className={Styled.fullscreenMedia}
                                />
                            ) : (
                                <img
                                    src={props.contents[selectedIndex]}
                                    alt="تصویر بزرگ‌شده"
                                    className={Styled.fullscreenMedia}
                                />
                            )}
                        </motion.div>
                    </motion.div>
                )}
            </AnimatePresence>

            {/* گالری همه با اسکرول افقی */}
            <AnimatePresence>
                {showAll && (
                    <motion.div
                        className={Styled.overlay}
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        onClick={closeGallery}
                    >
                        <motion.div
                            className={Styled.galleryScroll}
                            initial={{ opacity: 0, y: 30 }}
                            animate={{ opacity: 1, y: 0 }}
                            exit={{ opacity: 0, y: 30 }}
                            transition={{ type: "spring", stiffness: 300, damping: 30 }}
                            onClick={(e) => e.stopPropagation()}
                        >
                            {props.contents && props.contents.map((item, index) => (
                                props.contentType === "video" ? (
                                    <video
                                        key={index}
                                        src={item}
                                        controls
                                        className={Styled.galleryItem}
                                    />
                                ) : (
                                    <img
                                        key={index}
                                        loading="lazy"
                                        src={item}
                                        alt="تصویر نمونه کار"
                                        className={Styled.galleryItem}
                                    />
                                )
                            ))}
                        </motion.div>
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    );
}

export default ContentBox;

